package ai.flowstorm.studio.model

import ai.flowstorm.studio.common.state.AppState
import ai.flowstorm.studio.resources.SpaceResource
import kotlinx.serialization.Serializable
import ai.flowstorm.common.id.Id
import ai.flowstorm.common.id.newId
import ai.flowstorm.common.model.AbstractEntity

@Serializable
data class Persona(
    override val _id: Id = newId(),
    var name: String? = null,
    var publicName: String? = null,
    var description: String = "",
    var publicDescription: String? = null,
    var gender: String = "Male",
    var background: String? = null,
    var avatarId: String? = null,
    var icon: String? = null,
    var voice_id: Id? = null,
    var speechRecognizer_id: Id? = null,
    val space_id: Id = AppState.state.spaceId!!,
    var dialogue_id: Id? = null,
    var brain_id: Id? = null,
    var isStrong: Boolean = false,
) : AbstractEntity() {
    override val label
        get() = SpaceResource.get(space_id).let {
            "[${it.name}]$name"
        }

}